import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'


export const firebaseApp = firebase.initializeApp({
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DB_URL,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSAGING_SENDER_ID,
})
export const firebaseAuth = firebaseApp.auth()
export const firebaseDb = firebaseApp.database()



// WEBPACK FOOTER //
// ./src/modules/firebase/firebase.js